function initPcGenerateModal() {
  const modal = document.getElementById('generate-pc-modal');
  if (!modal) return;

  // Toggle OCAPI date input and PDF input based on selected source
  const radios = modal.querySelectorAll('input[name="permis_consolide[source]"]');
  const fileInputWrapper = modal.querySelector('[data-pc-file-input]');
  const ocapiInputWrapper = modal.querySelector('[data-pc-ocapi-input]');
  const pdfInput = fileInputWrapper?.querySelector('input[name="permis_consolide[pdf_file]"]');
  const principalApInput = ocapiInputWrapper?.querySelector('select[name="permis_consolide[principal_ap_id]"]');

  function updateVisibility() {
    const selected = modal.querySelector('input[name="permis_consolide[source]"]:checked');
    const isPdf = selected?.value === 'pdf';

    if (fileInputWrapper) fileInputWrapper.classList.toggle('fr-hidden', !isPdf);
    if (ocapiInputWrapper) ocapiInputWrapper.classList.toggle('fr-hidden', isPdf);

    if (pdfInput) pdfInput.required = isPdf;
    if (principalApInput) principalApInput.required = !isPdf;
  }

  radios.forEach((radio) => radio.addEventListener('change', updateVisibility));
  updateVisibility();

  // Close after successful form submission
  modal.addEventListener('turbo:submit-end', (event) => {
    if (event.detail.success) modal.classList.remove('open');
  });
}

document.addEventListener('turbo:load', initPcGenerateModal);
document.addEventListener('DOMContentLoaded', initPcGenerateModal);
